import { makeStyles } from "@fluentui/react-components";

export const useCategoryPopoverStyles = makeStyles({
    resultRow: {
        display: "flex",
        alignItems: "center",
        width: "100%",
        minWidth: 0
    },
    resultText: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        overflow: "text-overflow"
    },
    resultIcon: {
        width: "24px",
        minWidth: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "8px"
    },
    deleteButton: {
        opacity: 0,
        position: "absolute",
        right: "8px",
        top: "50%",
        transform: "translateY(-50%)"
    },
    resultContainer: {
        position: "relative",
        width: "100%",
        "&:hover .delete-button": {
            opacity: 1
        },
        "&:focus-within .delete-button": {
            opacity: 1
        }
    }
});
